/** Labels for per-branch receipt + internal sale number. */
export const BRANCH_RECEIPT_NUMBER_LABEL = 'Número de Recibo';
export const SALES_ORDER_NUMBER_LABEL = 'Número de Venta';

/** Tooltip for tentative receipt shown while arming a sale (not yet allocated). */
export const BRANCH_RECEIPT_TENTATIVE_TOOLTIP =
  'Número tentativo. Puede diferir si otra venta se confirma antes.';

/** Success screen: allocated receipt differs from the tentative one (another sale confirmed first). */
export const BRANCH_RECEIPT_CHANGED_MESSAGE =
  'El número de recibo cambió porque otra venta de esta sucursal se confirmó antes.';
